module.exports = __webpack_public_path__ + "img/preview.94c1abff.png";